import { MainContainer } from '@/components/atoms'
import { CreateSubscription, ManageSubscriptions } from '@/components/organisms'
import { Layout } from '@/components/templates'
import { useSubscriptionConfigs } from '@/hooks'
import { AbsoluteCenter, Box, Button, Spinner } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { useAccount } from 'wagmi'

export const SubscriptionsPage = () => {
  const { isConnected, isConnecting } = useAccount()
  const {
    data,
    isLoading: isLoadingSubs,
    refetch: refetchSubs,
  } = useSubscriptionConfigs()

  const isLoading = isConnecting || isLoadingSubs
  const isSubscribed = !isLoading && isConnected && data?.length > 0

  return (
    <Layout>
      <Box flex={1} position={'relative'}>
        {isLoading ? (
          <AbsoluteCenter>
            <Spinner color="primary.400" boxSize={28} speed=".5s" />
          </AbsoluteCenter>
        ) : (
          <>
            <MainContainer p={4}>
              <Button
                as={Link}
                style={{ textDecoration: 'none' }}
                to={'/calculator'}
                variant={'outline'}
              >
                VRF Cost Calculator
              </Button>
            </MainContainer>
            {isSubscribed ? (
              <ManageSubscriptions
                subscriptions={data}
                refetchSubs={refetchSubs}
              />
            ) : (
              <CreateSubscription refetchSubs={refetchSubs} />
            )}
          </>
        )}
      </Box>
    </Layout>
  )
}
